var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "a-entity",
    [
      _c(
        "a-yoga-layout",
        {
          staticClass: "clickable",
          attrs: {
            "width-auto": "1",
            "height-auto": "1",
            "flex-wrap": "nowrap",
            "flex-direction": "row",
            "align-items": "center",
            "justify-content": "space-between",
            "yoga-layout-item": "margin: 0.02; marginEdge: top",
            padding: "0.05",
            geometry: "primitive: rounded-plane;",
            material: "color: #001034;",
            "push-mesh-backwards": "",
          },
        },
        [
          _c("a-image", {
            staticClass: "clickable",
            attrs: {
              src: "/aframe-assets/icons/cancel-padded.png",
              width: "0.1",
              height: "0.1",
              "yoga-layout-item": "position: absolute; right:0.02; top:0.02",
              "ui-icon": "",
              "toggle-modal": "#debugPanel",
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }